/**
 * DemoBanner — Persistentes Demo-Modus-Banner (W3.1)
 *
 * Sichtbar auf allen Seiten waehrend Demo-Modus.
 * Light/Dark-Mode: nutzt CSS-Tokens fuer Kontrast (NFR43).
 */
import { useNavigate } from '@tanstack/react-router'
import { Info } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { useDemoMode } from '../hooks/useDemoMode'

export function DemoBanner() {
  const { t } = useTranslation('shell')
  const { isDemoMode, deactivate } = useDemoMode()
  const navigate = useNavigate()

  if (!isDemoMode) return null

  function handleExit() {
    deactivate()
    void navigate({ to: '/login' })
  }

  function handleUpgrade() {
    void navigate({ to: '/account/subscription' })
  }

  return (
    <div
      data-testid="demo-banner"
      role="status"
      aria-label={t('demo.ariaLabel')}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        padding: '8px 16px',
        background: 'var(--c-info-bg, color-mix(in srgb, var(--accent, #6366f1) 12%, transparent))',
        borderBottom: '1px solid var(--c-info-border, color-mix(in srgb, var(--accent, #6366f1) 25%, transparent))',
        fontSize: 13,
        color: 'var(--text)',
        flexWrap: 'wrap',
      }}
    >
      <Info
        size={14}
        aria-hidden="true"
        style={{ color: 'var(--accent, #6366f1)', flexShrink: 0 }}
      />
      <span style={{ flex: 1, minWidth: 200 }}>
        {t('demo.message')}
      </span>
      <div style={{ display: 'flex', gap: 8, flexShrink: 0 }}>
        <button
          className="btn btn-primary"
          style={{ fontSize: 12, padding: '4px 12px' }}
          onClick={handleUpgrade}
          data-testid="demo-banner-upgrade"
        >
          {t('demo.upgrade')}
        </button>
        <button
          className="btn btn-ghost"
          style={{ fontSize: 12, padding: '4px 12px' }}
          onClick={handleExit}
          data-testid="demo-banner-exit"
        >
          {t('demo.exit')}
        </button>
      </div>
    </div>
  )
}
